<template>
  <div class="swiper-card card-intro card-low-news">
    <svg width="56" height="46" viewBox="0 0 56 46" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M41.1508 0.803681C42.6114 0.326845 44.1728 1.10983 44.6449 2.55582L54.8863 33.9264C55.3584 35.3724 54.5598 36.9258 53.0992 37.4027C51.6386 37.8795 50.0772 37.0965 49.6051 35.6505L39.3636 4.27997C38.8916 2.83398 39.6902 1.28052 41.1508 0.803681ZM5.76343 26.667L36.723 5.14205L46.9645 36.5126L35.0847 36.793C35.3032 40.4552 33.0222 43.9571 29.3336 45.1614C24.9601 46.5892 20.2649 44.2347 18.8514 39.905C18.558 39.0063 18.4294 38.081 18.4486 37.1888L9.26794 37.4016C9.6444 38.8065 8.84651 40.2784 7.43543 40.739C5.97484 41.2159 4.41343 40.4329 3.94136 38.9869L0.527534 28.5301C0.0554658 27.0841 0.854105 25.5306 2.3147 25.0538C3.72578 24.5931 5.23843 25.3106 5.76343 26.667ZM30.9237 36.8858L22.6235 37.0824C22.5942 37.5801 22.6552 38.1026 22.8206 38.6091C23.5273 40.774 25.8749 41.9513 28.0617 41.2373C29.9596 40.6177 31.1119 38.777 30.9237 36.8858Z" fill="black"/>
    </svg>

    <h1>Little news on !!SUBJECT!! today.</h1>
    <p>Honestly, there's not much reporting on this stack today, and that's ok.</p>
    <p>Sometimes a topic has little news worth reading, and we're all about giving you the right news to read, not the unneccesary news.</p>
    <p>Come back tomorrow, but today you can take a break from !!SUBJECT!!.</p>

    <button @click="$emit('next')">Ok! I'll be back</button>
  </div>
</template>

<script>
  export default {
    props: {
      slide: {
        type: Object
      },
      meta: {
        type: Object,
      },
      stack: {
        type: Object,
      },
    },

    mounted () {
      this.$emit('enableNextAction');
    },
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5_stacks.scss';

  .card-low-news {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 3rem;

    svg {
      margin-bottom: 2rem;
      
      path {
        fill: $yellow-tone-3;
      }
    }

    p {
      margin-top: 1rem;
    }

    button {
      margin-top: 2rem;
    }
  }
</style>